import React from 'react';
import { connect } from 'react-redux';
import config from "config"
import {
	selectSensorButton,
	selectNodeFilter,
	needData, deleteSensor,
	selectSensorStatusFilter
} from "actions/sensorsettings"
import { fetchLiveData } from "actions/node"

import NodeDropdown from "components/common/dropdowncomponents/nodedropdown"
import ListDropdown from "components/common/dropdowncomponents/listdropdown"
import Path from "components/common/path"

import SensorList from "./sensorlist"
import EditModal from "./editModal"

import DeleteModal from "./deleteModal"
import MainMenu from 'components/common/mainmenu';
import StickyMenu from "components/common/stickymenu"
import StatsMenu from "components/common/statsmenu"
class SensorSettings extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			I: {},
			DOpen: false, // delete sensor modal open ?
			Drespond: "",
			DrespondClass: "",

			EOpen: false, // edit sensor modal open ?
			Erespond: "",
			ErespondClass: ""
		};
	}

	DOpen() {
		this.setState({ DOpen: true });
	}

	DClose() {
		this.props.dispatch(selectSensorButton({}));
		this.setState({ DOpen: false });
	}

	EOpen() {
		this.setState({ EOpen: true });
	}

	EClose() {
		this.props.dispatch(selectSensorButton({}));
		this.setState({ EOpen: false });
	}

	fetchData() {
		this.props.dispatch(fetchLiveData())
	}

	componentDidMount() {
		this.fetchData();
		var self = this;
		var I = setInterval(function () { self.fetchData() }, 5000);
		this.setState({ I: I });
	}

	componentWillUnmount() {
		clearInterval(this.state.I);
	}

	componentWillReceiveProps(nextProps) {
		// Init nodeFilter
		if (this.props.nodeFilter.id == -2 && nextProps.tree.id != -2) {
			this.props.dispatch(selectNodeFilter(nextProps.tree));
		}
		// Editing stages
		switch (nextProps.Estage) {
			case "editing":
				this.setState({
					Erespond: "Editing...",
					ErespondClass: "text-loading"
				});
				if (nextProps.fetched) {
					this.props.dispatch(needData());
				}
				break;
			case "edited":
				this.setState({
					Erespond: "Sensor edited.",
					ErespondClass: "text-green"
				});
				if (!nextProps.fetched) {
					this.fetchData();
				}
				break;
			case "edit-failed":
				this.setState({
					Erespond: "Failed to edit this sensor !",
					ErespondClass: "text-red"
				})
				break;
			default: // "nothing"
				this.setState({
					Erespond: "",
					ErespondClass: ""
				});
		}
		// Deleting stages
		switch (nextProps.Dstage) {
			case "deleting":
				if (nextProps.fetched) {
					this.props.dispatch(needData());
				}
				break;
			case "deleted":
				if (!nextProps.fetched) {
					this.fetchData();
				}
				this.DClose();
				break;
			default: // nothing
		}

	}

	getPath() {
		var cur = this.props.nodeFilter, tmp = [], path = [];
		while (cur) {
			tmp.push(cur);
			cur = cur.parent;
		}
		// reverse tmp to get the path.
		while (tmp.length) {
			path.push(tmp[tmp.length - 1]);
			tmp.pop();
		}
		return path
	}

	listNodeFilter(root, res) {
		var self = this;
		if (root) {
			if (root.type != "sensor") {
				res.push(root);
				root.children.forEach((child) => {
					self.listNodeFilter(child, res);
				})
			}
		}
	}

	clickDeleteButton() {
		this.props.dispatch(deleteSensor(this.props.selectedSensor));
	}

	linkOn(x) {
		return true;
	}

	link(x) {
		return null
	}

	onClick(e, x) {
		e.preventDefault()
		this.props.dispatch(selectNodeFilter(x));
	}
	render() {
		return (
			<div className="sensor-settings-page overwrite--modal--depth">
				<StickyMenu
					withStickyHeader={false}
				>
					<MainMenu
						overviewIsActive={false}
						comparisonIsActive={false}
						onlyLeftMenu={true}
					/>

					<StatsMenu
						leftItemBold="Sensor Settings"
						leftItems={
							<React.Fragment>
								<span className="stats-menu__select stats-menu__list-item " >
									<NodeDropdown
										outsideClass="dropdown-btn settings-dropdown pull-left"
										root={this.props.tree}
										nodeFilter={this.props.nodeFilter}
										click={
											(node) => { this.props.dispatch(selectNodeFilter(node)) } /* this.props.dispatch(useradSelectNode(node)) }*/
										}
										list={this.listNodeFilter.bind(this)}
										header="All locations"
									/>
								</span>
								<span className="stats-menu__select stats-menu__list-item " >
									<ListDropdown
										outsideClass="dropdown-btn settings-dropdown pull-left"
										items={config.sensorStatusFilter}
										getText={(x) => x.text}
										selected={this.props.sensorStatusFilter}
										click={(status) => { this.props.dispatch(selectSensorStatusFilter(status)) }}
									/>
								</span>
							</React.Fragment>
						}
					/>

					<Path
						path={this.getPath()}
						linkOn={this.linkOn.bind(this)}
						link={this.link.bind(this)}
						onClick={this.onClick.bind(this)}
					/>
				</StickyMenu>
				<div className="page-content page-content_padding-modifier">
					<div className="display--flex__flex--start--center">
						<div className="sensors-table-wrapper">
							<SensorList
								root={this.props.nodeFilter}
								statusFilter={this.props.sensorStatusFilter}
								sensorMap={this.props.sensorMap}
								nodeMap={this.props.nodeMap}
								openDeleteModal={this.DOpen.bind(this)}
								openEditModal={this.EOpen.bind(this)}
								selectedSensor={this.props.selectedSensor}
							/>
							<EditModal
								open={this.state.EOpen}
								closeModal={this.EClose.bind(this)}
								sensor={this.props.selectedSensor}
								respond={this.state.Erespond}
								respondClass={this.state.ErespondClass}
							/>
							<DeleteModal
								open={this.state.DOpen}
								closeModal={this.DClose.bind(this)}
								respond={this.state.Drespond}
								respondClass={this.state.DrespondClass}
								clickButton={this.clickDeleteButton.bind(this)}
							/>
						</div>
					</div >
				</div >
			</div >
		);
	}
}

function mapStateToProps(state) {
	return {
		tree: state.overviewReducer.customerOverview,
		nodeMap: state.overviewReducer.nodeMap,
		sensorMap: state.nodeReducer.map,
		me: state.myAccountReducer.user,

		selectedSensor: state.sensorSettingsReducer.selectedSensor,
		nodeFilter: state.sensorSettingsReducer.nodeFilter,
		sensorStatusFilter: state.sensorSettingsReducer.sensorStatusFilter,


		Estage: state.sensorSettingsReducer.Estage,
		Erespond: state.sensorSettingsReducer.Erespond,

		Dstage: state.sensorSettingsReducer.Dstage,
		Drespond: state.sensorSettingsReducer.Drespond,
		fetched: state.sensorSettingsReducer.fetched

	};
}

function mapDispatchToProps(dispatch) {
	return {
		dispatch
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(SensorSettings);



// WEBPACK FOOTER //
// ./src/components/pages/sensorsettings/index.jsx